import { render, staticRenderFns } from "./AppAnnotationPart3.vue?vue&type=template&id=264d389c&scoped=true"
import script from "./AppAnnotationPart3.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart3.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart3.vue?vue&type=style&index=0&id=264d389c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d389c",
  null
  
)

export default component.exports